import { useInfiniteQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { giftPackageService } from '../../../services/gifts/gift-packages'
import { setGraphClientAuthToken } from '../../../services/graph-client'

export const GIFT_PACKAGES_QUERY_KEY = ['getGiftPackages']

export const useGetGiftPackages = (
  options?: { enabled?: boolean; token?: string | null } | boolean,
) => {
  const enabled = typeof options === 'boolean' ? options : (options?.enabled ?? true)
  const token = typeof options === 'boolean' ? undefined : options?.token

  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: GIFT_PACKAGES_QUERY_KEY,
    initialPageParam: 0,
    staleTime: 0,
    enabled,
    queryFn: ({ pageParam: skip }) => {
      setGraphClientAuthToken(token)
      return giftPackageService.get({ take: 8, skip })
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage?.error) {
        return null
      }

      if (lastPage && !lastPage?.data?.length) {
        return null
      }

      return lastPageParam + 1
    },
  })

  const gifts = useMemo(() => {
    const packages = data?.pages?.flatMap((page) => {
      return page?.data?.map((gift) => ({
        ...gift.gift,
        quantity: gift?.quantity,
        isPackage: true,
      }))
    })

    return packages?.filter((giftPackage) => giftPackage?.quantity > 0)
  }, [data?.pages])

  return {
    gifts,
    totalPages: data?.pages?.[0]?.totalPages ?? 0,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    nextPage: fetchNextPage,
  }
}
